export default __webpack_public_path__ + "static/media/development.6be0ef9e.jpg";